import Builder from '..';

export const build = (AssignConfig, resource) => {
  try {
    const variableName = AssignConfig.name;
    const variableValue = Builder.build(AssignConfig.assignValue, resource);

    if (typeof resource === 'undefined') {
      resource = {};
    }

    if (typeof resource.variableEnvironment === 'undefined') {
      resource.variableEnvironment = {};
    }

    resource.variableEnvironment[variableName] = variableValue;
    // return resource;
    return variableValue;
  } catch (error) {
    return undefined;
  }
};

export const type = 'Assign';
